export default __webpack_public_path__ + "static/media/dani-verse.94248b0d.jpeg";